import { useState } from "react";
import S from "../styles/styles";
import { Logo, Field } from "./UI";
import { IS_CONFIGURED, sbForgotPassword } from "../utils/supabase";

const ForgotPassword = ({ onBack }) => {
  const [email,   setEmail]   = useState("");
  const [status,  setStatus]  = useState("idle"); // idle | sending | sent | error
  const [message, setMessage] = useState("");

  const handleSend = async () => {
    if (!email) { setMessage("Please enter your email address."); setStatus("error"); return; }

    setStatus("sending");

    if (!IS_CONFIGURED) {
      // Demo mode — show instructions
      setStatus("sent");
      setMessage("demo");
      return;
    }

    try {
      await sbForgotPassword(email);
      setStatus("sent");
    } catch (err) {
      setStatus("error");
      setMessage(err.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <div style={S.body}>
      <div style={S.authWrap}>
        <div style={S.authCard}>
          <div style={{ marginBottom: 24, cursor: "pointer", color: "#9993A8", fontSize: 13 }} onClick={onBack}>
            ← Back to Sign In
          </div>
          <Logo />

          <div style={{ marginTop: 28, marginBottom: 8, fontSize: 20, fontWeight: 800 }}>
            Reset your password
          </div>
          <div style={{ fontSize: 13, color: "#9993A8", marginBottom: 24, lineHeight: 1.6 }}>
            Enter your account email and we'll send you a reset link.
          </div>

          {/* ── Sent ── */}
          {status === "sent" && message === "demo" && (
            <div style={{ ...S.infoBanner, flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>ℹ️ Demo Mode</div>
              <div style={{ fontSize: 13, lineHeight: 1.6 }}>
                Password reset emails require Supabase to be configured.
                Once your database is set up, renters will receive a reset
                link at their email automatically.
              </div>
              <div style={{ fontSize: 12, color: "#2A7BE899", marginTop: 4 }}>
                For now, use the demo credentials on the login screen.
              </div>
            </div>
          )}

          {status === "sent" && message !== "demo" && (
            <div style={S.successBanner}>
              ✅ Reset link sent! Check your inbox (and spam folder).
            </div>
          )}

          {status === "error" && (
            <div style={S.errorBox}>⚠ {message}</div>
          )}

          {status !== "sent" && <>
            <Field label="Email Address">
              <input
                style={S.input}
                placeholder="you@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
              />
            </Field>
            <button
              style={{ ...S.btnPrimary, width: "100%", marginTop: 4, opacity: status === "sending" ? 0.7 : 1 }}
              onClick={handleSend}
              disabled={status === "sending"}
            >
              {status === "sending" ? "Sending..." : "Send Reset Link →"}
            </button>
          </>}

          {status === "sent" && (
            <button style={{ ...S.btnSecondary, width: "100%", marginTop: 16 }} onClick={onBack}>
              Back to Sign In
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
